'use client';

import { useEffect } from 'react';

import Link from 'next/link';

import { Button } from '@heroui/react';
import { catalog } from '@onark/observability';

import { AnalyticsProvider } from './_components/AnalyticsProvider';

/**
 * The one 404 for the whole app. Once app/ exists, Next renders the App
 * Router's not-found for EVERY 404, including `notFound: true` from a pages/
 * getServerSideProps (base-server renderErrorToResponseImpl tries
 * /_not-found before pages/404). With no file here that was Next's bare
 * built-in page, from 2026-07-06 until this replaced it.
 *
 * Guests hit this (a stale class link, a mistyped church URL), so the copy is
 * written for them, not for pastors.
 */
export default function NotFound() {
  useEffect(() => {
    catalog.emit('navigation.not_found_viewed', {
      path: window.location.pathname,
      referrer: document.referrer || undefined,
    });
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-background px-4">
      <AnalyticsProvider />
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <p className="text-sm font-medium text-muted">404</p>
        <h1 className="text-3xl font-semibold text-foreground">
          We can&apos;t find that page.
        </h1>
        <p className="text-muted">
          The link may be broken, or the page may have moved. If a church sent
          you this link, check with them for the latest one.
        </p>
        <Button
          variant="primary"
          onPress={() => {
            // A guest who opened the link straight from a text has no history.
            if (window.history.length > 1) window.history.back();
            else window.location.assign('/');
          }}
        >
          Go back
        </Button>
        <Link className="text-sm text-muted underline" href="/">
          OnArk home
        </Link>
      </div>
    </main>
  );
}
